import { getUserTimezone } from './getUserTimezone';

/**
 * Creates a time formatter for chart time display
 */
export function createTimeFormatter(locale?: string, timezone?: string) {
  const tz = timezone || getUserTimezone();
  const fmt = new Intl.DateTimeFormat(locale, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: tz
  });

  return (ts: number) => fmt.format(new Date(ts * 1000));
}
